// extracted by mini-css-extract-plugin
export default {"modal":"tP_GkUJE7ME13teT2pFS"};